import { render } from "./VTable.vue?vue&type=template&id=29d98bbb&ts=true"
import script from "./VTable.vue?vue&type=script&lang=ts"
export * from "./VTable.vue?vue&type=script&lang=ts"

import "./VTable.vue?vue&type=style&index=0&id=29d98bbb&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__